import { Box, Theme, Typography } from '@material-ui/core';
import { createStyles, makeStyles } from '@material-ui/styles';
import React, { useState } from 'react';
import { AllowVolunteerMatching } from './AllowVolunteerMatching';
import { MatchingRulesForm } from './MatchingRulesForm';

const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    container: {
      paddingLeft: 40,
      paddingRight: 40,
      paddingTop: 20,
      backgroundColor: '#F9F9F9',
      minHeight: 'calc(100% - 20px)',
    },
    contentContainer: {
      background: 'white',
      paddingTop: '1.25rem',
      paddingBottom: '1.25rem',
      paddingLeft: '1.875rem',
      paddingRight: '1.875rem',
      marginTop: '2.25rem',
    },
    heading: {
      alignItems: 'center',
      paddingBottom: '8px',
      borderBottom: '1px solid #efefef',
    },
    headingTitle: {
      color: theme.color.grey.neutralBrand900,
      fontWeight: 600,
      paddingBottom: '5px',
      fontSize: 20,
    },
  })
);

const AdminConsoleMatchingPanel = () => {
  const classes = useStyles();
  const [matchingEnabled, setMatchingEnabled] = useState(false);

  return (
    <Box className={classes.container}>
      <Box className={classes.heading}>
        <Typography variant='h2' className={classes.headingTitle}>
          Application Actions
        </Typography>
        <Typography variant={'body2'}>
          {'Manage settings and configuration for actions taken on incoming volunteer applications'}
        </Typography>
      </Box>
      <Box style={{ marginTop: '25px' }} className={classes.contentContainer}>
        <AllowVolunteerMatching onChange={setMatchingEnabled} />
      </Box>
      {matchingEnabled && (
        <Box style={{ marginTop: '25px' }} className={classes.contentContainer}>
          <MatchingRulesForm enabled={matchingEnabled} />
        </Box>
      )}
    </Box>
  );
};

export { AdminConsoleMatchingPanel };
